import { useUrlParam } from './use-url-param';
export function useUrlModeParam() {
    return useUrlParam('mode', {
        fromParam: (x) => x,
        toParam: (x) => x
    });
}
